import _classCallCheck from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/broford/website/ford-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { createNoDashGuid } from "./Guid";
export var EventType;

(function (EventType) {
  EventType[EventType["Debug"] = 0] = "Debug";
  EventType[EventType["Info"] = 1] = "Info";
  EventType[EventType["Warning"] = 2] = "Warning";
  EventType[EventType["Error"] = 3] = "Error";
})(EventType || (EventType = {}));

export var PlatformEvent = /*#__PURE__*/function () {
  function PlatformEvent(eventName, eventType) {
    _classCallCheck(this, PlatformEvent);

    this.privName = eventName;
    this.privEventId = createNoDashGuid();
    this.privEventTime = new Date().toISOString();
    this.privEventType = eventType;
    this.privMetadata = {};
  }

  _createClass(PlatformEvent, [{
    key: "name",
    get: function get() {
      return this.privName;
    }
  }, {
    key: "eventId",
    get: function get() {
      return this.privEventId;
    }
  }, {
    key: "eventTime",
    get: function get() {
      return this.privEventTime;
    }
  }, {
    key: "eventType",
    get: function get() {
      return this.privEventType;
    }
  }, {
    key: "metadata",
    get: function get() {
      return this.privMetadata;
    }
  }]);

  return PlatformEvent;
}();